import { Box, TextField, Typography } from "@mui/material";
import { CreatePrescriptionOrderRequestDto } from "libs/cellera-sdk";
import { useCelleraTheme } from "theme/useCelleraTheme";

interface ShippingInfoFormProps {
  shippingInfo: CreatePrescriptionOrderRequestDto;
  onChange: (info: CreatePrescriptionOrderRequestDto) => void;
  errors?: Partial<Record<keyof CreatePrescriptionOrderRequestDto, string>>;
}

export const ShippingInfoForm = ({
  shippingInfo,
  onChange,
  errors,
}: ShippingInfoFormProps) => {
  const { colors } = useCelleraTheme();

  const handleChange =
    (field: keyof CreatePrescriptionOrderRequestDto) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange({
        ...shippingInfo,
        [field]: event.target.value,
      });
    };

  return (
    <Box
      sx={{
        border: `1px solid ${colors.border.light}`,
        borderRadius: "8px",
        p: "16px",
        backgroundColor: colors.background.paper,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          color: colors.text.primary,
          mb: 2,
        }}
      >
        Shipping Information
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <TextField
          label="Shipping Address"
          value={shippingInfo.shippingAddress}
          onChange={handleChange("shippingAddress")}
          error={!!errors?.shippingAddress}
          helperText={errors?.shippingAddress}
          fullWidth
          required
        />

        <Box sx={{ display: "flex", gap: 2 }}>
          <TextField
            label="City"
            value={shippingInfo.city}
            onChange={handleChange("city")}
            error={!!errors?.city}
            helperText={errors?.city}
            fullWidth
            required
          />

          <TextField
            label="State"
            value={shippingInfo.state}
            onChange={handleChange("state")}
            error={!!errors?.state}
            helperText={errors?.state || "2-letter code (e.g., CA)"}
            fullWidth
            required
            inputProps={{ maxLength: 2 }}
          />

          <TextField
            label="ZIP Code"
            value={shippingInfo.zip}
            onChange={handleChange("zip")}
            error={!!errors?.zip}
            helperText={errors?.zip}
            fullWidth
            required
          />
        </Box>

        <TextField
          label="Country"
          value={shippingInfo.country}
          onChange={handleChange("country")}
          error={!!errors?.country}
          helperText={errors?.country}
          fullWidth
          required
        />
      </Box>
    </Box>
  );
};
